// Portfolio Administration v1.0 PR 5 — Agreements tab on the Local
// Enforcer registry detail page. The list endpoint exists at GET
// /local-enforcers/{id}/agreements (PR 2b); for now the panel renders
// an empty-state pointer because the request shape is broadly stable
// and the table is a thin presentation layer. Wiring the full agreement
// list is intentionally minimal — UI ships with the registry page in
// PR 5, full agreement-editor UX lands with the enforcer documents
// workstream.

import { EmptyTabCard } from "@/components/portfolioAdmin/registry/EmptyTabCard";

export function EnforcerAgreementsTab() {
  return (
    <EmptyTabCard
      title="Agreements"
      description="MSA, engagement-letter templates, amendments, terminations, and NDAs are tracked here. The browse + drawer UX lands with the enforcer documents workstream — record new agreements via the documents tab in the meantime."
      testId="enforcer-agreements-tab"
    />
  );
}
